__turbopack_context__.v({
  "Logo": "logo-link-module__7otETW__Logo",
});
